{
  "allApps": "모든 앱",
  "back": "주로 돌아가기",
  "myApps": "내 앱",
  "viewMoreApps": "추가 앱 보기"
}
